<template>
  <button
    type="button"
    class="step-verdict-button"
    :class="[`step-verdict-button--${verdict}`, { 'step-verdict-button--selected': selected }]"
    :aria-pressed="selected ? 'true' : 'false'"
    :disabled="disabled"
    @click="emit('click')"
  >
    {{ label }}
  </button>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  verdict: {
    type: String,
    default: "pass",
    validator: (value) => ["pass", "fail"].includes(value),
  },
  selected: {
    type: Boolean,
    default: false,
  },
  /** Not clickable (read-only after the final decision, or while saving). The colours are kept. */
  disabled: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["click"]);

const label = computed(() => (props.verdict === "fail" ? "Fail" : "Pass"));
</script>

<style scoped>
.step-verdict-button {
  min-width: 64px;
  padding: 4px 14px;
  border: 1px solid #d0d5dd;
  border-radius: 8px;
  background: #ffffff;
  color: #344054;
  font-family: Inter, sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  cursor: pointer;
}

.step-verdict-button:hover:not(:disabled) {
  background: #f9fafb;
}

.step-verdict-button:focus-visible {
  outline: 2px solid #2c0cfa;
  outline-offset: 2px;
}

.step-verdict-button--pass.step-verdict-button--selected {
  border-color: #abefc6;
  background: #ecfdf3;
  color: #067647;
}

.step-verdict-button--fail.step-verdict-button--selected {
  border-color: #fecdca;
  background: #fef3f2;
  color: #b42318;
}

.step-verdict-button:disabled {
  cursor: default;
}

.step-verdict-button:disabled:not(.step-verdict-button--selected) {
  color: #667085;
}
</style>
